import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { media } from 'context';
import { Animate, Button, Layout, Link, Logo, Text } from 'ds';
import { ROOT_PATH } from 'routes';

import StepTitle from './StepTitle';

import { ReactComponent as AiAssistantIcon } from 'ds/ai-assistant.svg';

interface Props {}

const ServicesRequestConfirmation: React.FC<Props> = () => {
  const history = useHistory();
  const { isMobile } = useContext(media);

  if (isMobile) {
    return (
      <Layout
        flex
        height="100vh"
        background="linear-gradient(86deg, rgba(0, 120, 255, 0.05) 0%, rgba(142, 95, 244, 0.05) 100%)"
        align="center"
        position="relative"
        paddingX={24}
      >
        <Layout gap={12} flex>
          <AiAssistantIcon style={{ flexShrink: 0 }} width={40} height={40} />
          <Layout>
            <StepTitle>Thanks! I’ll reach out soon.</StepTitle>
            <Animate marginTop={24} delay={150}>
              <Text size="body-md" color="gray-400">
                Want to skip the wait?{' '}
                <Link
                  size="body-md"
                  semibold={false}
                  href="https://meetings.hubspot.com/christelle-rohaut/demo"
                  display="inline"
                >
                  Schedule a call now
                </Link>
              </Text>
            </Animate>
          </Layout>
        </Layout>
        <Layout position="absolute" top={40} left={40}>
          <Logo color="blue-500" size="sm" />
        </Layout>
        <Layout position="absolute" top={40} right={40}>
          <Button size="xs" type="secondary" text="Exit" onClick={() => history.push(ROOT_PATH)} />
        </Layout>
      </Layout>
    );
  }

  return (
    <Layout
      flex
      height="100vh"
      background="linear-gradient(86deg, rgba(0, 120, 255, 0.05) 0%, rgba(142, 95, 244, 0.05) 100%)"
      align="center"
      position="relative"
      paddingX={80}
    >
      <Layout>
        <StepTitle>Thanks! I’ll reach out soon.</StepTitle>
        <Animate marginTop={24} marginLeft={96} delay={250}>
          <Text size="body-xl" color="gray-400">
            Want to skip the wait?{' '}
            <Link
              size="body-xl"
              semibold={false}
              display="inline"
              href="https://meetings.hubspot.com/christelle-rohaut/demo"
            >
              Schedule a call now
            </Link>
          </Text>
        </Animate>
      </Layout>
      <Layout position="absolute" top={40} left={40}>
        <Logo color="blue-500" />
      </Layout>
      <Layout position="absolute" top={40} right={40}>
        <Button size="xs" type="secondary" text="Exit" onClick={() => history.push(ROOT_PATH)} />
      </Layout>
    </Layout>
  );
};

export default ServicesRequestConfirmation;
